import {dataTestId} from '@hconnect/uikit/src/common'
import {Close} from '@mui/icons-material'
import {IconButton, Stack, DialogTitle} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useDialog} from '../../providers'

export const OptimizerConstraintsDialogHeader: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {closeDialog} = useDialog()

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <DialogTitle variant="h3" sx={{p: 1}}>
        {t('optimizer.constraintsDialogTitle')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeDialog}
        color="info"
        {...dataTestId('optimizer_constraints_dialog_close_button')}
      >
        <Close />
      </IconButton>
    </Stack>
  )
}
